import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { pickBy as _pickBy } from 'lodash';

import SelectList from '../components/Common/SelectList/SelectList';

import {
    setNewBookingPickupLocation,
} from '../actions/newBooking';

class PickupLocationSelectorContainer extends Component {
    render() {
        const locationsWithPlant = _pickBy(this.props.locations, location => location.hasPlant);

        return (
            <SelectList
                title="Pickup From"
                items={locationsWithPlant}
                selectedItemId={this.props.pickupLocationId}
                setSelectedItem={this.props.setNewBookingPickupLocation}
            />
        );
    }
}

function mapStateToProps(state) {
    const { locations } = state.entities;
    // When this container is used to edit location, we will need to pass selected location and the set action into the container.
    const { pickupLocationId } = state.newBooking;

    return {
        locations,
        pickupLocationId,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingPickupLocation
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PickupLocationSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/PickupLocationSelectorContainer.jsx